const actionTypes = {
    GET_EVENTS_BY_GROUP_REPORT_SUCCESS: 'GET_EVENTS_BY_GROUP_REPORT_SUCCESS',
    GET_EVENTS_BY_EACH_GROUP_REPORT_SUCCESS: 'GET_EVENTS_BY_EACH_GROUP_REPORT_SUCCESS',
    SET_EVENTS_BY_EACH_GROUP_REPORT_SUCCESS: 'SET_EVENTS_BY_EACH_GROUP_REPORT_SUCCESS',
};

export default actionTypes;
